// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wd1v","signatureBlock":"Footer_signatureBlock__2WdVD","signature":"Footer_signature__kfk_a"};